import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { apiGetWarrantyNotes } from 'services/LoveWarrantyServices'

export const getWarrantyNotes = createAsyncThunk('warrantyNotes/data/getWarrantyNotes', async (data) => {
    const response = await apiGetWarrantyNotes(data);
    return response.data;
})

const dataSlice = createSlice({
    name: 'warrantyNotes/data',
    initialState: {
        loading: false,
        warrantyNotes: [],
        editingNote: null,
    },
    reducers: {
        setWarrantyNotes: (state, action) => {
            state.warrantyNotes = action.payload
        },
        discardData: (state) => {
            state.warrantyNotes = []
        },
        setEditingNote: (state, action) => {
            state.editingNote = action.payload
        },
    },
    extraReducers: {
        [getWarrantyNotes.fulfilled]: (state, action) => {
            state.warrantyNotes = action.payload
            state.loading = false
        },
        [getWarrantyNotes.pending]: (state) => {
            state.loading = true
        },
    },
})

export const {
    discardData,
    setWarrantyNotes,
    setEditingNote,
} = dataSlice.actions


export default dataSlice.reducer
